import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import PropTypes from "prop-types";
import { Icon, Tooltip } from "@mui/material";
import CustomModal from "../../../../examples/Modal/ConfirmationModal";
import { useEffect, useState } from "react";
import { useAuth } from "context";
import VerifiedIcon from "@mui/icons-material/Verified";
import MDTypography from "components/MDTypography";

function EmailVerification({
  emailData,
  index,
  onSendOTP,
  onFieldChange,
  onVerify,
  onUnlinked,
  isSendingOTP,
  customerPhoneNumber,
  isConfirmationModal,
  confirmationModalLoader,
  isForgotPassword,
}) {
  const isEmailValid = (email) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailPattern.test(email);
  };

  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const { darkMode } = useAuth();
  const handleClose = () => {
    setIsOpenConfirmationModal(!isOpenConfirmationModal);
  };
  const handleConfirm = () => {
    onUnlinked(index);
  };
  return (
    <>
      <MDBox key={index} mb={2} style={{ display: emailData.isVerified && "flex" }}>
        <MDBox style={{ display: "flex", flexDirection: "column" }} mb={2}>
          <MDBox style={{ display: "flex" }}>
            <MDInput
              required
              type="email"
              label="Email"
              name="email"
              variant="outlined"
              value={emailData.email}
              disabled={
                emailData.disabled ||
                emailData.isVerified ||
                (!isForgotPassword && emailData.isOTPVisible)
              }
              onChange={(e) => onFieldChange(e, index)}
              error={!isEmailValid(emailData.email)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor:
                      !emailData.isVerified && isEmailValid(emailData.email)
                        ? "#ef5350"
                        : "rgba(0, 0, 0, 0.42)",
                  },
                },
              }}
            />
            {/* Keeping just the delete icon */}
            <MDBox>
              {!isForgotPassword && emailData.isOTPVisible && (
                <Icon
                  color="error"
                  sx={{ cursor: "pointer", mt: 1.2, ml: 1.3 }}
                  onClick={() =>
                    isConfirmationModal ? setIsOpenConfirmationModal(true) : onUnlinked(index)
                  }
                >
                  delete
                </Icon>
              )}
            </MDBox>
          </MDBox>

          {/* WhatsApp-style verification UI */}
          {!emailData.isVerified && isEmailValid(emailData.email) && customerPhoneNumber !== "" && (
            <MDBox display="flex" alignItems="center" mt={1} gap={0.5}>
              <Icon
                sx={{
                  color: "#ef5350",
                  fontSize: "18px",
                  display: "flex",
                  alignSelf: "center",
                }}
              >
                warning
              </Icon>
              <MDBox display="flex" alignItems="center" gap={1}>
                <MDTypography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    lineHeight: 1.5,
                  }}
                >
                  Pending verification.
                </MDTypography>
                <MDTypography
                  component="span"
                  variant="body2"
                  color="success.main"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.2s",
                    color: "#248756",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => onSendOTP(index)}
                >
                  Send Verification Code
                </MDTypography>
              </MDBox>
            </MDBox>
          )}
        </MDBox>

        {/* Existing OTP verification section */}
        {emailData.isOTPVisible && customerPhoneNumber !== "" && (
          <MDBox>
            {!emailData.isVerified && (
              <MDInput
                type="text"
                label="Verification Code"
                name="otpNumber"
                variant="outlined"
                placeholder="123456"
                value={emailData.otpNumber}
                onChange={(e) => onFieldChange(e, index)}
                inputProps={{
                  maxLength: 6,
                  style: {
                    textAlign: "center",
                    letterSpacing: "0.5em",
                    fontWeight: "600",
                  },
                }}
              />
            )}

            {emailData.isVerified ? (
              <>
                <Tooltip sx={{ mt: 1.2, ml: 2, mr: 2 }} title={"Verified"} placement="top">
                  <VerifiedIcon color={"success"} />
                </Tooltip>
              </>
            ) : (
              <MDButton
                variant="contained"
                color="success"
                onClick={() => onVerify(index)}
                disabled={!emailData.otpNumber}
                sx={{
                  minWidth: "120px",
                  ml: 1,
                }}
              >
                VERIFY
              </MDButton>
            )}
          </MDBox>
        )}
      </MDBox>

      <CustomModal
        open={isOpenConfirmationModal}
        handleClose={handleClose}
        color={"success"}
        title={`Are you sure want to unlink?`}
        userEmail={emailData?.email}
        description={
          emailData.isVerified
            ? "Any future orders placed using this email will not be counted."
            : ""
        }
        onConfirm={handleConfirm}
        loader={confirmationModalLoader}
        isIcon={false}
      />
    </>
  );
}

// Define prop types
EmailVerification.propTypes = {
  emailData: PropTypes.shape({
    email: PropTypes.string,
    isOTPVisible: PropTypes.bool,
    otpNumber: PropTypes.string,
    disabled: PropTypes.bool,
    isVerified: PropTypes.bool,
    isAuthFlow: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onSendOTP: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onVerify: PropTypes.func.isRequired,
  onUnlinked: PropTypes.func.isRequired,
  isSendingOTP: PropTypes.bool,
  isConfirmationModal: PropTypes.any,
  confirmationModalLoader: PropTypes.bool,
  isForgotPassword: PropTypes.bool,
  customerPhoneNumber: PropTypes.string,
};

export default EmailVerification;
